module.exports = __webpack_public_path__ + "img/img5.4dd4e43a.png";